const FieldsCard = ({ children, title, description, borderBottom = true }) => {
  return (
    <div className="w-full">
      <div className="flex flex-col gap-3 lg:flex-row lg:justify-between lg:gap-8">
        {/* Left Section */}
        <div className="w-full lg:max-w-[280px] shrink-0">
          <h3 className="text-xs font-bold text-gray-800">
            {title}
          </h3>

          <p className="mt-1 text-xs font-normal text-gray-600">
            {description}
          </p>
        </div>

        {/* Right Section */}
        <div className="w-full lg:max-w-[500px] xl:max-w-[600px]">
          {children}
        </div>
      </div>

      {borderBottom && (
        <div className="my-5 h-px w-full bg-gray-200" />
      )}
    </div>
  );
};

export default FieldsCard;
